function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useState, useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import { nanoid } from "nanoid";
import useField from "../hooks/internal/useField";
import { mergeProps } from "../utils/component";
import Field from "./internal/Field";
import OTPInput from "./internal/InternalOtpInput";
import useTheme from "../hooks/useTheme";
import useBackground from "../hooks/useBackground";
import useResponsivePropsCSS from "../hooks/useResponsivePropsCSS";
import { jsx as ___EmotionJSX } from "@emotion/core";
var DEFAULT_PROPS = {
  codeLength: 6,
  disabled: false,
  optional: false,
  color: "grey.t05",
  shouldAutoFocus: true,
  validate: function validate(value, _ref) {
    var isEmpty = _ref.isEmpty;

    if (isEmpty(value)) {
      return "Required";
    }

    if (value.length !== 6) {
      return "Must be 6 digits";
    }

    return null;
  }
};
export default function OtpInput(props) {
  var mergedProps = mergeProps(props, DEFAULT_PROPS, {}, {
    codeLength: function codeLength(_codeLength) {
      return typeof _codeLength === "number";
    },
    disabled: function disabled(_disabled) {
      return typeof _disabled === "boolean";
    },
    optional: function optional(_optional) {
      return typeof _optional === "boolean";
    },
    shouldAutoFocus: function shouldAutoFocus(_shouldAutoFocus) {
      return typeof _shouldAutoFocus === "boolean";
    },
    value: function value(_value) {
      return typeof _value === "string";
    }
  });
  var name = mergedProps.name,
      codeLength = mergedProps.codeLength,
      disabled = mergedProps.disabled,
      optional = mergedProps.optional,
      onChangeProp = mergedProps.onChange,
      label = mergedProps.label,
      helpText = mergedProps.helpText,
      testId = mergedProps.testId,
      validate = mergedProps.validate,
      validateData = mergedProps.validateData;
  var isEmpty = useCallback(function (value) {
    return value.trim() === "";
  }, []);
  var validationData = useMemo(function () {
    return _objectSpread({
      isEmpty: isEmpty
    }, validateData && {
      data: validateData
    });
  }, [isEmpty, validateData]);

  var _useState = useState(function () {
    return "otp-input-".concat(nanoid());
  }),
      _useState2 = _slicedToArray(_useState, 1),
      otpInputId = _useState2[0];

  var _useState3 = useState(function () {
    return "otp-input-aux-".concat(nanoid());
  }),
      _useState4 = _slicedToArray(_useState3, 1),
      auxId = _useState4[0];

  var _useField = useField("OtpInput", {
    name: name,
    disabled: disabled,
    optional: optional,
    validate: validate,
    data: validationData
  }),
      value = _useField.value,
      errors = _useField.errors,
      hasErrors = _useField.hasErrors,
      onFocus = _useField.onFocus,
      onBlur = _useField.onBlur,
      fieldOnChange = _useField.onChange;

  var onChange = useCallback(function (otpValue) {
    fieldOnChange({
      target: {
        value: otpValue,
        name: name
      }
    });
    onChangeProp && onChangeProp(otpValue);
  }, [fieldOnChange, onChangeProp, name]);
  return ___EmotionJSX(Field, {
    optional: optional,
    disabled: disabled,
    label: label,
    labelFor: otpInputId,
    auxId: auxId,
    helpText: helpText,
    errors: errors,
    testId: testId
  }, ___EmotionJSX(OTPInput, {
    id: otpInputId,
    value: value,
    onChange: onChange,
    numInputs: codeLength,
    containerStyle: {
      gap: "4px"
    },
    inputType: "number",
    renderInput: function renderInput(inputProps, index) {
      return ___EmotionJSX(InternalInput, {
        name: name,
        inputProps: inputProps,
        hasErrors: hasErrors,
        disabled: disabled,
        onFocus: onFocus,
        onBlur: onBlur,
        index: index
      });
    }
  }));
}
OtpInput.DEFAULT_PROPS = DEFAULT_PROPS;
OtpInput.propTypes = {
  name: PropTypes.string.isRequired,
  color: PropTypes.string,
  codeLength: PropTypes.number,
  isDisabled: PropTypes.bool,
  shouldAutoFocus: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func,
  validate: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  validateData: PropTypes.any,
  label: PropTypes.string.isRequired,
  helpText: PropTypes.node,
  testId: PropTypes.string
};

function InternalInput(props) {
  var hasErrors = props.hasErrors,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      index = props.index,
      name = props.name,
      disabled = props.disabled,
      _props$inputProps = props.inputProps,
      style = _props$inputProps.style,
      otpInputProps = _objectWithoutProperties(_props$inputProps, ["style"]);

  var theme = useTheme();

  var _useBackground = useBackground(),
      inputColorMap = _useBackground.inputColorMap;

  var inputCSS = useResponsivePropsCSS(props, DEFAULT_PROPS, {
    color: function color(propsAtBreakpoint, theme, bp) {
      var _props$color;

      var color = (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : inputColorMap[bp];
      return theme.otpInput.getCSS({
        targetElement: "input",
        color: color
      });
    }
  });
  var internalOnFocus = useCallback(function (event) {
    otpInputProps.onFocus(event);
    onFocus(event);
  }, [otpInputProps, onFocus]);
  var internalOnBlur = useCallback(function (event) {
    otpInputProps.onBlur(event);
    onBlur(event);
  }, [otpInputProps, onBlur]);
  return ___EmotionJSX("div", {
    css: theme.input.getCSS({
      targetElement: "inputContainer"
    })
  }, ___EmotionJSX("input", _extends({
    "aria-invalid": hasErrors ? "true" : null
  }, otpInputProps, {
    css: inputCSS,
    disabled: disabled,
    name: name,
    onFocus: internalOnFocus,
    onBlur: internalOnBlur,
    index: index,
    pattern: "[0-9]",
    type: "text"
  })));
}

InternalInput.propTypes = {
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  color: PropTypes.string,
  hasErrors: PropTypes.bool.isRequired,
  onFocus: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  inputProps: PropTypes.object.isRequired
};